
import { addLayerExist, removerLayerExist, getLayerExist } from '../layerStatusControl'

/**
 * 基于航道数据添加 航道数据展示
 * @param {*} params 数据参数
 * @param {*} viewer 展示 viewer
 */
function addSailLineGeoJsonLayer (params, viewer) {
  // 获取数据
  const dataList = params.data.list
  const startUrl = params.startUrl
  // ': '../.././extension/meros-standard-sealanes/public/start_point.png',
  const endUrl = params.endUrl
  //  'endUrl': '../.././extension/meros-standard-sealanes/public/end_point.png'
  const fromPort = params.data.FromPort || 'DALIAN'

  const toPort = params.data.ToPort || 'SINGAPORE'
  // 基于 dataList 构建 点线面czml 数据
  const dataczml = getCZMLSail(dataList, startUrl, endUrl, fromPort, toPort)
  var dataSourcePromise = Cesium.CzmlDataSource.load(dataczml)
  viewer.dataSources.add(dataSourcePromise)
    .then(function (dataSource) {
      const addInfo = {
        info: params,
        layer: dataczml,
        market: dataSource
      }
      addLayerExist(addInfo)
    })
  addHoverOverLayer(viewer, params)
  return true
}

var sailHover = null
function addHoverOverLayer (viewer, params) {
  const hover = params.data.hover
  // const container = creatHoverElement(hover.title, [], {}, params.data)
  var scene = viewer.scene
  var handler = new Cesium.ScreenSpaceEventHandler(scene.canvas)
  // 一 鼠标MOUSE_MOVE
  const container = document.createElement('div')
  container.id = 'hoverSail3D'
  container.style.backgroundColor = 'white'
  container.style.zIndex = 10
  container.style.position = 'absolute'
  const hoverFather = document.getElementById('cesiumContainer')
  hoverFather.appendChild(container)
  handler.setInputAction(function (movement) {
    var pick = viewer.scene.pick(movement.endPosition)
    if (Cesium.defined(pick) && pick.id) {
      const name = pick.id.name
      const info = pick.id.properties
      if (name.indexOf('point') === 0) {
        sailHover = changeHoverElement(hover.title, hover.items, info)
        const position = viewer.scene.cartesianToCanvasCoordinates(
          pick.id.position._value
        )
        sailHover.style.left = position.x + 10 + 'px'
        sailHover.style.top = position.y + 10 + 'px'
        sailHover.style.display = 'block'
        // sailHover.style.cursor = 'pointer'
      }
    } else {
      const sailHover = document.getElementById('hoverSail3D')
      sailHover.style.display = 'none'
      // sailHover.style.cursor = 'default'
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
}

function changeHoverElement (title, items, properties) {
  const container = document.getElementById('hoverSail3D')
  container.innerHTML = ''
  const _title = document.createElement('p')
  _title.innerHTML = title
  _title.className = 'hoverSail3D-title'
  const _items = document.createElement('ul')
  _items.className = 'hoverSail3D-items'
  items.forEach((item) => {
    const li = document.createElement('li')
    const label = document.createElement('span')
    label.className = 'hoverSail3D-items__label'
    label.innerHTML = `${item.label}: `
    li.appendChild(label)

    let value = properties[item.value]
    switch (item.value) {
      case 'center':
        value = [properties.Lon, properties.Lat]
        break
      default:
        value = properties[item.value]
        break
    }

    const text = document.createElement('span')
    text.innerHTML = `${value} ${item.unit}`
    li.appendChild(text)
    if (!value) {
      text.innerHTML = ''
    }
    _items.appendChild(li)
  })
  container.appendChild(_title)
  container.appendChild(_items)
  return container
}

function getImageInfo (position, img, title, alllength) {
  const Lat = position.Lat
  const Lon = position.Lon
  const icon = {
    id: 'some-unique-id' + title,
    name: title,
    billboard: {
      image: img,
      scale: 1.0
    },
    label: {
      fillColor: {
        rgba: [255, 255, 255, 255]
      },
      font: '12pt Lucida Console',
      horizontalOrigin: 'LEFT',
      pixelOffset: {
        cartesian2: [8, 0]
      },
      style: 'FILL',
      text: title,
      showBackground: true,
      backgroundColor: {
        rgba: [112, 89, 57, 0]
      }
    },
    zIndex: alllength,
    position: {
      cartographicDegrees: [Lon, Lat, 0]
    }
  }
  return icon
}

function getCZMLSail (dataList, startUrl, endUrl, fromPort, toPort) {
  var czml = [
    {
      id: 'document',
      name: 'CZML Point',
      version: '1.0'
    }
  ]
  const line = makeLine(dataList)
  czml.push(line)
  for (let i = 1; i < dataList.length - 1; i++) {
    const pointi = dataList[i]
    const pointczmli = makePoint(pointi, i, pointi)
    czml.push(pointczmli)
  }

  // 开始结束点
  if (startUrl) {
    const point0 = dataList[0]
    const beginIcon = getImageInfo(point0, startUrl, fromPort, 0)
    beginIcon.zIndex = dataList.length + 1
    czml.push(beginIcon)
  }
  if (endUrl) {
    const pointlast = dataList[dataList.length - 1]
    const endIcon = getImageInfo(pointlast, endUrl, toPort, 1)
    endIcon.zIndex = dataList.length + 2
    czml.push(endIcon)
  }
  return czml
}

function makeLine (list, color) {
  color = color || [255, 0, 0, 255]
  const cartographicDegrees = []
  list.forEach(line1 => {
    const Lat = line1.Lat
    const Lon = line1.Lon
    cartographicDegrees.push(Lon)
    cartographicDegrees.push(Lat)
    cartographicDegrees.push(0)
  })
  const line = {
    id: 'redLine',
    name: 'Red line clamped to terain',
    polyline: {
      positions: {
        cartographicDegrees: cartographicDegrees
      },
      material: {
        polylineDash: {
          color: {
            rgba: color
          }
        }
      },
      width: 2,
      clampToGround: true
    }
  }
  return line
}

function makePoint (point, i, info) {
  const Lat = point.Lat
  const Lon = point.Lon
  const properties = {}
  for (const key in info) {
    // 由于属性 不能为空值 所以移除原有空值null部分
    if (info[key]) {
      properties[key] = info[key]
    }
  }

  const pointI = {
    id: 'point ' + i,
    name: 'point ' + i,
    position: {
      cartographicDegrees: [Lon, Lat, 0],
      zIndex: i + 2
    },
    properties: properties,
    point: {
      zIndex: i + 2,
      color: {
        rgba: [255, 255, 255, 255]
      },
      outlineColor: {
        rgba: [255, 0, 0, 255]
      },
      outlineWidth: 2,
      pixelSize: 4
    }
  }
  return pointI
}

function removeSailLineGeoJsonLayer (layerInfo, viewer) {
  const info = getLayerExist(layerInfo)

  if (info) {
    const sailItem = info.market
    viewer.dataSources.remove(sailItem)
    removerLayerExist(layerInfo)
  }
}

export { addSailLineGeoJsonLayer, removeSailLineGeoJsonLayer }
